export const productFilters = {
  g: "Grocery",
  f: "Fruits",
  v: "Vegetables",
  c: "Corona Items",
};
